<script setup>
import { ref, onMounted, computed } from 'vue';
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
// import appConfig from "../../../app.config";
import axios from 'axios';
import { authHeader } from '../../helpers/authservice/auth-header';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

const user = computed(() => JSON.parse(localStorage.getItem('user')));

const title = ref('Payment Report');

const items = ref([
  {
    text: "Home",
  },
    {
    text: "Reports",
  },
  {
    text: "Payment Report",
    active: true,
  },
]);

const baseURL = computed(() => axios.defaults.baseURL);

const humanfriendlyConfig = ref({
  altInput: true,
  altFormat: "F j, Y",
  dateFormat: "Y-m-d"
});

const searchParams = ref({
  lgu: 'all',
  from: '',
  to: '',
});

const lgus = ref({});
//const fileName = ref(null);

const getLGUs = async () => {
  try {
    const response = await axios.get(`search/user/${user.value.id}/lgus-and-cameras`, {
      headers: authHeader()
    })

    lgus.value = response.data.data.lgus;

  } catch (err) {
    console.log(err);
  }
  
}

const clickSearch = () => {
  // console.log(searchParams.value);
}

onMounted(async () => {
  await getLGUs();
  //fileName.value.focus();
})
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="container-fluid">
          <div class="row">
              <div class="col-md-12 col-xl-3">
                <b-overlay :show="loading">
                    <div class="card">
                      <!-- <div class="card-header">
                        <h3>General Search</h3>
                      </div> -->
                      <div class="card-body">
                          <form @submit.prevent="clickSearch" action="">
                              <div class="mb-3 text-center">
                                <label for="search-status-*" class="form-label">LGU Name</label>
                                <select v-model="searchParams.lgu" class="form-select" id="lgu">
                                  <option value="all">All</option>
                                  <option v-for="(lgu, name) in lgus" :value="name" :key="name">{{ lgu }}</option>
                              </select>
                              </div>
                              <div class="mb-3 text-center">
                                <label for="violation_date" class="form-label">Date of Payment</label>
                                <div class="d-flex">
                                  <flatPickr
                                    id="date"
                                    placeholder="From"
                                    v-model="searchParams.from"
                                    :config="humanfriendlyConfig"
                                    class="form-control flatpickr-input mr-1"
                                  ></flatPickr>
                                  <flatPickr
                                    id="date"
                                    placeholder="To"
                                    v-model="searchParams.to"
                                    :config="humanfriendlyConfig"
                                    class="form-control flatpickr-input ml-1"
                                  ></flatPickr>
                                </div>
                              </div>
                              <div class="text-center mt-5">
                                  <a :href="`${baseURL}/report/payment?user=${user.id}&${Object.keys(searchParams).map(key => `${key}=${searchParams[key]}`).join('&')}`" download target="_blank"
                                   class="btn btn-info btn-sm float-right np-btn">
                                  <i class="tn btn-primary mdi mdi-microsoft-excel align-middle mr-1 fs-5 text-white"></i>
                                  Export Summary</a>
                              </div>
                          </form>
                      </div>
                    </div>
                </b-overlay>
              </div>
          </div>
        </div>
  </Layout>
</template>
